var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{ref:"navbar",staticClass:"appbar white",class:_vm.mainTenantName == 'sait' ? 'pa-4' : '',staticStyle:{"z-index":"5 !important"},attrs:{"app":"","clipped-left":"","height":_vm.navbarHeight}},[(_vm.mainTenantName == 'sait')?_c('NavbarSite',{attrs:{"primaryLinks":_vm.primaryLinks}}):_c('NavbarShop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }